<template>
    <ion-modal :is-open="isOpenRef" @onDidDismiss="setOpen(false)">
        <product-card :item="item" :sku="sku" :shipment-line="shipmentLine" />
    </ion-modal>
</template>

<script>
import {IonModal} from '@ionic/vue';
import ProductCard from "@/components/Modals/ProductCard";
import { ref } from 'vue';
export default {
    name: "ProductCardModal",
    props: ['item', 'sku', 'shipment-line'],
    components: {
        IonModal, ProductCard
    },
    methods: {
        open() {
            this.setOpen(true);
        }
    },
    setup() {
        const isOpenRef = ref(false);
        const setOpen = (state) => isOpenRef.value = state;
        return { isOpenRef, setOpen }
    }
}
</script>
